import React, { useState, useEffect, useRef } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col, Modal, Dropdown, Badge, Button, Tab, Tabs, Form, Accordion } from 'react-bootstrap';
import { faPlus, faXmark, faCircle, faPaperclip, faBolt, faCircleXmark, faLink, faArrowLeft, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';
import ImageUpload from '../../../../Components/common/ImageUpload';
import ActivityComments from '../../../../Components/common/ActivityComments';
import edit from "../../../../assets/images/edit.png";
import Docmnt from '../../../../assets/images/google-docs.png';
import Rapdf from "../../../../assets/images/pdf.png";
import Edit from "../../../../assets/images/pen.png";
import Trash from "../../../../assets/images/trash.png";
import Export from "../../../../assets/images/export.svg";
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Select from 'react-select';
import pen from "../../../../assets/images/pen.png";
import { withRFSToken } from '../../../../Services/axios';
import { GETDESTINATION } from '../../../../Utils/conts';
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions';

const Release = () => {

  const isMounted = useRef(false);
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [modalData, setModalData] = useState();
  const [modalType, setModalType] = useState('C');
  const [companyOption, setCompanyOption] = useState([]);
  const [damageType, setDamageType] = useState([]);
  const [totalRows, setTotalRows] = useState({});
  const [totalRowsR, setTotalRowsR] = useState(0);
  const [filterApplied, setFilterApplied] = useState(false);
  const [activeTab, setActiveTab] = useState('Active');
  const [resetFilter, setResetFilter] = useState(false);
  const [getDestination, setGetDestination] = useState([]);
  const [getPackaging, setGetPackaging] = useState([]);
  const [switchData, setSwitchData] = useState();
  const gridRefs = {
    Active: useRef(null),
    Archived: useRef(null),
  };
  const [gridData, setGridData] = useState({
    Active: [
      { shipment_number: 'Ams-AE-279101', take_in: 'kjhjk', ttl_pcs: 'jhgjhk', ttl_weight: '54', location: 'hgf' },
    ],
    Archived: [
      { shipment_number: 'Ams-AE-279102', take_in: 'kjhjk', ttl_pcs: 'jhgjhk', ttl_weight: '54', location: 'hgf' },
    ],
    // Trash: []

  });
  const CustomerOptions = [
    // { label: '--', value: '' },
    { label: 'Airline', value: 'A' },
    { label: 'Forwarder', value: 'F' },
    { label: 'Handler', value: 'H' },
    { label: 'Trucker', value: 'T' }
  ];
  const acceptanceWarehouseInhandlerOptions = [
    { label: '--', value: '-' },
    { label: 'Transfer', value: 'Transfer' },
    { label: 'NCTS', value: 'NCTS' },
    { label: 'IM4', value: 'IM4' },

  ];
  const loadCompany = async () => {
    try {
      const res = await withRFSToken.get('address-book/dropdown', {})
        .then(function (res) {
          const innerData = res.data.response_data;
          // console.log("🚀 ~ .then ~ innerData:654", innerData)
          const transformedData = innerData ? innerData.map(item => ({
            value: item.value,
            label: item.label,
          })) : [];
          setCompanyOption(transformedData);

        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const loadHAWB = async (cargoid) => {
    try {
      //console.log("🚀 Loading HAWB for cargoid:", cargoid);
      const res = await withRFSToken.get(`shipment/release-sub-mawb?cargoid=${cargoid}`);
      const innerData = res.data.Rows;
      // console.log("🚀 ~ innerData:", innerData);

      const transformedData = innerData
        ? innerData.map((item) => ({
          id: item.id,
          import_shipment_record_id: item.import_shipment_record_id,
          hawb: item.house_awb,
          label: item.label,
          pick_status: item.pick_status,
          location: item.location,
          picked_pc: item.pcs_stock,
          actual_pcs_snapshot: item.pcs_stock,
          r_pcs: item.released_pcs,
          picklist: item.picklist,
          is_deliver: 1,
          warehouse_out_doc_type: 'Transfer',
          warehouse_out: new Date()
            .toLocaleString("sv-SE", { hour12: false })
            .replace(" ", "T")
            .slice(0, 16),
        }))
        : [];
      setModalData({
        mawb_id: cargoid, // Using parameter not gridSelect[0].cargoid
        hawb_details: transformedData,
      });
      return transformedData;
    } catch (error) {
      throw error;
    }
  };
  const fetchDestination = async () => {
    try {

      const res = await withRFSToken.post(GETDESTINATION, {})
        .then(function (res) {
          const innerData = res.data.response_data;
          const transformedData = innerData ? innerData.map(item => ({
            value: item.station_id,
            label: item.port_code,
            // address: item.address,
            // station_id: item.station_id
          })) : [];
          setGetDestination(transformedData);
          //   console.log("trans",transformedData);
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchPackaging = async () => {
    try {

      const res = await withRFSToken.post('shipment/type-of-packaging', {})
        .then(function (res) {
          const innerData = res.data.response_data;
          const transformedData = innerData ? innerData.map(item => ({
            value: item.id,
            label: item.description,
          })) : [];
          setGetPackaging(transformedData);
          //   console.log("trans",transformedData);
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchRule = async () => {
    try {
      const res = await withRFSToken.get('shipment/get-general-settings', {});
      // .then(function (res) {
      if (res.data.response_code === 200) {
        const innerData = res.data.response_data
        const reData = innerData[0]?.status == 1 ? true : false;
        setSwitchData(reData);
      } else {
        toast.error(res.data.response_msg);
      }

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }


  useEffect(() => {
    if (isMounted.current) return;
    setIsLoading(false);
    setGridData({ Active: {} });
    fetchDestination();
    fetchPackaging();
    fetchRule();
    isMounted.current = true;
  }, []);
  const [subMawb, setSubMawb] = useState(false)
  const loadHawbDetails = async (localData) => {
    //console.log("🚀 ~ loadHawbDetails ~ localData:", localData)
    try {

      const res = await withRFSToken.post('shipment/get-movement-log', { shipment_record_id: [localData.import_shipment_record_id], type: 'delivered' })
        .then(function (res) {
          const innerData = res.data.response_data;
          const transData = { ...localData, mvtLog: innerData }
          setSelectedRowData(transData);
          setSubMawb(true);
          setTimeout(() => {
            window.$(gridRefs[activeTab].current).jqxGrid("refresh");
          }, 30);
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const loadMawbDetails = async (localData) => {
    // console.log("🚀 ~ loadHawbDetails ~ localData:", localData)
    try {
      const cargoid = localData?.cargoid;
      const subRes = await withRFSToken.get(`shipment/release-sub-mawb?cargoid=${cargoid}`);
      const subRows = (subRes && subRes.data && subRes.data.Rows) ? subRes.data.Rows : [];
      const shipmentRecordIds = subRows.map(row => row?.import_shipment_record_id).filter(Boolean);

      const res = await withRFSToken.post('shipment/get-movement-log', { shipment_record_id: shipmentRecordIds, type: 'released' })
        .then(function (res) {
          const innerData = res.data.response_data;
          const transData = { ...localData, mvtLog: innerData }
          setSelectedRowData(transData);
          // setSubMawb(true);
          setTimeout(() => {
            window.$(gridRefs[activeTab].current).jqxGrid("refresh");
          }, 30);
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };


  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedRowDetails, setSelectedRowDetails] = useState(null);
  const [gridSelect, setGridSelect] = useState([]);


  const handleTabChange = async (tab) => {
    setActiveTab(tab);
    // const tabType = () => {tab == 'Active' ? 'A' : 'R'}
    setFilterApplied(false);
    if (selectedRowData) {
      setSelectedRowData(null)
    }
    setGridSelect([]);
    setIsLoading(true);
    if (tab == 'Active') {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Active: {} });
      }, 1);
    } else {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Archived: {} });
      }, 1);
    }
  }

  //---------------- upload data files start------------------------>

  const handleFormChange = (name, value) => {
    if (name === 'mawb') {
      value = handleChange(value);
    }
    // setFormData((prevFormData) => ({
    //   ...prevFormData,
    //   [name]: value,
    // }));
    setFormData((prevFormData) => {
      let updatedForm = {
        ...prevFormData,
        [name]: value,
      };

      // if (name === 'label_present' && value === 'N') {
      //   const { storage_loc, label, shipment_no, ...rest } = updatedForm;
      //   updatedForm = rest;
      // }

      return updatedForm;
    });
  }

  // const handleModalOpen = (contentType) => {
  //   setModalContent(contentType);
  //   setShowModal(true);
  // };
  const handleChange = (value) => {
    value = value.replace(/[^\d]/g, ''); // Remove any non-numeric characters
    let formattedValue = '';

    // Add a hyphen after the third character
    if (value.length > 3) {
      formattedValue += value.substr(0, 3) + '-';
      value = value.substr(3);
    }

    // Add a space after the eighth character
    if (value.length > 4) {
      formattedValue += value.substr(0, 4) + ' ';
      value = value.substr(4);
    }

    formattedValue += value;
    return formattedValue.substr(0, 13);
  };

  const [formData, setFormData] = useState({
    mawb: '',
    airport_origin: '', consignee_name: '',
  });
  const [shipmentGroups, setShipmentGroups] = useState([
    { packaging: '', e_pcs: '', e_weight: '', files: [] }
  ]);

  const handleAddGroup = () => {
    setShipmentGroups([
      ...shipmentGroups,
      { packaging: '', e_pcs: '', e_weight: '', files: [] }
    ]);
  };

  // const handleGroupChange = (index, field, value) => {
  //   const updatedGroups = [...shipmentGroups];
  //   updatedGroups[index][field] = value;
  //   setShipmentGroups(updatedGroups);
  // };

  const handleGroupChange = (index, field, value, mod) => {
    if (mod) {
      const updatedGroups = [...modalData.hawb_details];

      if (field == 'is_deliver') {
        if (value == '1') {
          // Set picked_pcs, released_pcs, delivered_pcs to snapshot value each time
          const snapshot = updatedGroups[index].actual_pcs_snapshot;
          updatedGroups[index] = {
            ...updatedGroups[index],
            [field]: value,
            //picked_pcs: '',
            //released_pcs: '',
            delivered_pcs: '',
          };
        } else {
          updatedGroups[index] = {
            ...updatedGroups[index],
            [field]: value,
            released_pcs: '',
            delivered_pcs: '',
          };
        }
      } else {
        updatedGroups[index] = {
          ...updatedGroups[index],
          [field]: value,
        };
      }

      setModalData((prevData) => ({
        ...prevData,
        hawb_details: updatedGroups,
      }));
    } else {
      const updatedGroups = [...shipmentGroups];

      updatedGroups[index] = {
        ...updatedGroups[index],
        [field]: value,
      };

      // if (field === 'pcs_conf' && value === 'N') {
      //   const { a_pcs, a_weight, loc, ...rest } = updatedGroups[index];
      //   updatedGroups[index] = rest;
      // }

      setShipmentGroups(updatedGroups);
    }

  };

  const handleGroupFileChange = (index, event) => {
    const selectedFiles = Array.from(event.target.files);
    const updatedGroups = [...shipmentGroups];
    updatedGroups[index].files = [...(updatedGroups[index].files || []), ...selectedFiles];
    setShipmentGroups(updatedGroups);
  };

  const handleGroupDrop = (index, e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    const updatedGroups = [...shipmentGroups];
    updatedGroups[index].files = [...(updatedGroups[index].files || []), ...droppedFiles];
    setShipmentGroups(updatedGroups);
  };

  const handleGroupDragOver = (e) => {
    e.preventDefault();
  };

  const handleGroupDeleteFile = (groupIdx, fileIdx) => {
    const updatedGroups = [...shipmentGroups];
    updatedGroups[groupIdx].files = updatedGroups[groupIdx].files.filter((_, idx) => idx !== fileIdx);
    setShipmentGroups(updatedGroups);
  };

  const handleDeleteGroup = (groupIdx) => {
    setShipmentGroups(prevGroups => prevGroups.filter((_, idx) => idx !== groupIdx));
  };

  const [savedHouseAwbs, setSavedHouseAwbs] = useState([]);
  const [houseAwbInput, setHouseAwbInput] = useState('');
  const [editIndex, setEditIndex] = useState(null);
  const [hawbShow, setHawbShow] = useState(true);

  const handleSaveHawb = () => {
    if (!houseAwbInput.trim()) {
      toast.error("House AWB's is required!");
      return;
    }
    if (editIndex !== null) {
      // Update existing
      setSavedHouseAwbs(prev => prev.map((item, idx) => idx === editIndex ? { hawb_no: houseAwbInput, packing_groups: shipmentGroups } : item));
      setEditIndex(null);
    } else {
      setSavedHouseAwbs(prev => [...prev, { hawb_no: houseAwbInput, packing_groups: shipmentGroups }]);
    }
    setShipmentGroups([{ packaging: '', e_pcs: '', e_weight: '', files: [] }]);
    setHouseAwbInput('');

    setHawbShow(false)
  };

  const handleEditHawb = (idx) => {
    setShipmentGroups(savedHouseAwbs[idx].packing_groups);
    setHouseAwbInput(savedHouseAwbs[idx].hawb_no);
    setEditIndex(idx);
    setHawbShow(true)
  };

  const handleDeleteHawb = (idx) => {
    setSavedHouseAwbs(prev => prev.filter((_, i) => i !== idx));
    // If editing the deleted one, reset
    if (editIndex === idx) {
      setShipmentGroups([{ packaging: '', e_pcs: '', e_weight: '', files: [] }]);
      setHouseAwbInput('');
      setEditIndex(null);
    }
  };

  const [mawbModal, setMawbModal] = useState(false);
  const [modalFor, setModalFor] = useState('');

  const closeModal = () => {
    setMawbModal(false);
    setFormData({
      mawb: '',
      airport_origin: '', consignee_name: '',
    });
    setHouseAwbInput('');
    setSavedHouseAwbs([]);
    setHawbShow(true);
  }

  const handleConfirmation = async () => {
    let endPoint = '';
    let payload = {};

    if (modalFor === 'B') {
      endPoint = 'shipment/import-instock-back-to-back-save';
      payload = { ...formData, packing_groups: shipmentGroups }
    } else {
      endPoint = 'shipment/import-instock-consolidated-save';
      payload = { ...formData, hawbs: savedHouseAwbs }
    }
    // console.log("🚀 ~ handleConfirmation ~ payload:", payload)
    try {
      const res = await withRFSToken.post(endPoint, payload)
        .then(function (res) {
          const innerData = res.data.response_data;
          setTimeout(() => {
            setIsLoading(false);
            window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata')
          }, 1);
          setMawbModal(false);
          setFormData({
            mawb: '',
            airport_origin: '', consignee_name: '',
          });
          setSavedHouseAwbs([]);
          setHouseAwbInput('');
          setHawbShow(true);
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
    // window.location.href = '/ULDControl'

  }

  const handleDropdownItemClick = (pos, action) => {
    if (action === 'C' || action === 'B') {
      setShipmentGroups([
        { packaging: '', e_pcs: '', e_weight: '', files: [] }
      ]);

      setModalFor(action);
      setMawbModal(true);
    } else {
      if (activeTab == 'Active') {
        if (gridSelect.length !== 1) {
          toast.error('Please select exactly one MAWB to release');
          return;
        }
        if((gridSelect[0].inspection_statuses).includes("on_hold") || (gridSelect[0].inspection_statuses).includes("rejected")){
            toast.error("Cannot release when Inspection Status is On Hold or Rejected");
          return;
        }
        loadHAWB(gridSelect[0].cargoid);
        setIsModal(true);
        loadCompany();
      } else if (activeTab == 'Archived') {
        if (gridSelect.length < 1) {
          toast.error('Please select at least one HAWB to release');
          return;
        }
        if(gridSelect[0].inspection_status == "on_hold" || gridSelect[0].inspection_status == "rejected"){
          toast.error("Cannot release when Inspection Status is On Hold or Rejected");
          return;
        }
        const transformedData = gridSelect ? gridSelect.map(item => ({
          hawb: item.house_awb,
          id: item.hawb_id,
          label: item.label,
          pick_status: item.pick_status,
          location: item.location,
          //picked_pc: item.pcs_stock,
          // delivered_pcs: item.pcs_stock,
          actual_pcs_snapshot: item.pcs_stock,
          r_pcs: item.released_pcs,
          is_deliver: '1',
          warehouse_out_doc_type: 'Transfer',
          picklist: item.picklist,
          warehouse_out: new Date().toLocaleString('sv-SE', { hour12: false }).replace(' ', 'T').slice(0, 16),
        })) : [];
        setModalData({
          mawb_id: gridSelect[0].id,
          hawb_details: transformedData
        });
        setIsModal(true);
        loadCompany();
      }
    }

  };

  const modalInputChange = (name, value) => {
    setModalData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  }

  let checkUlds = [];
  let filterForCheck = false;
  useEffect(() => {
    if (gridRefs[activeTab]?.current) {
      // if (gridData[activeTab]) {
      // var token = "Bearer " + localStorage.RFS;
      jqxCookieCall()
      let endPoint = '';
      if (activeTab == 'Active') { endPoint = 'shipment/release-mawb' } else { endPoint = 'shipment/release' }
      const source = {
        datatype: 'json',
        datafields: [
          { name: 'id', type: 'string' },
          { name: 'master_airway_bill', type: 'string' },
          { name: 'take_in', type: 'date' },
          { name: 'airport_origin', type: 'string' },
          { name: 'expected_pieces', type: 'string' },
          { name: 'expected_weight', type: 'string' },
          { name: 'accepted_pcs', type: 'string' },
          { name: 'pcs_stock', type: 'string' },
          { name: 'inspection_status', type: 'string' },
          { name: 'inspection_statuses', type: 'string' },
          // { name: 'pcs_picked', type: 'string' },
          { name: 'picked', type: 'string' },
          { name: 'delivered', type: 'string' },
          { name: 'consignee_name', type: 'string' },
          { name: 'status', type: 'string' },

          { name: 'acceptedBorderColor', type: 'string' },
          { name: 'pickedBorderColor', type: 'string' },
          { name: 'deliveredBorderColor', type: 'string' },
          { name: 'hawb_accepted_border_color', type: 'string' },
          { name: 'hawb_id', type: 'string' },
          { name: 'releaseStatus', type: 'string' },
          { name: 'cargoid', type: 'string' },

          //active hawb datafields
          { name: 'release_number', type: 'string' },
          { name: 'house_awb', type: 'string' },
          { name: 'master_awb', type: 'string' },
          { name: 'take_in', type: 'date' },
          { name: 'acceptance', type: 'string' },
          { name: 'expected_pcs', type: 'string' },
          { name: 'expected_weight', type: 'string' },
          { name: 'accepted_pcs', type: 'string' },
          { name: 'pcs_stock', type: 'string' },
          { name: 'pieces_picked', type: 'string' },
          { name: "released_pcs", type: "string" },
          { name: 'consolidate_pdf', type: 'string' },
          { name: 'trucking_company', type: 'string' },
          { name: 'release', type: 'string' },
          { name: 'picklist_pdf', type: 'string' },
          { name: 'delivery_status', type: 'string' },
          { name: 'release_pcs', type: 'string' },
          { name: 'import_shipment_record_id', type: 'string' },
          { name: 'delivery_pcs', type: 'string' },
          { name: 'total_deliver_pcs', type: 'string' },
        ],
        id: `${activeTab}-`,
        url: `${process.env.REACT_APP_RFS_URL}${endPoint}`,
        // beforeSend: function (jqXHR) {
        //   jqXHR.setRequestHeader('Authorization', token);
        // },
        // localdata: gridData[activeTab],
        pagesize: 50,
        filter: function (allfilters) {
          if (allfilters.length > 0) {
            setFilterApplied(true);
            filterForCheck = true;
          } else {
            setFilterApplied(false);
            filterForCheck = false;
          }
          window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
          window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");


          // setTimeout(() => {
          //     const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');

          //     console.log("rows", rows);
          //     (checkUlds).forEach(uldNumber => {
          //         console.log(checkUlds);
          //         rows.forEach((element, index) => {
          //             if (element.uld_number == uldNumber) {
          //                 window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
          //             }
          //         });
          //     });
          // }, 4000);
        },
        beforeprocessing: function (data) {
          source.totalrecords = data.TotalRows;
          setTotalRows({ totalUlds: data.activeCount });
          setTotalRowsR({ totalUlds: data.archiveCount });
        },
        sort: function () {
          window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
        },
        root: "Rows",
        cache: false,
      };
      const dataAdapter = new window.$.jqx.dataAdapter(source);
      let columns = [];
      if (activeTab === 'Active') {
        columns = [
          { text: 'Master Airway Bill', filtertype: 'input', datafield: 'master_airway_bill', width: '8%', cellclassname: '', },
          { text: 'Take In', filtertype: 'range', cellsformat: 'dd-MM-yyyy', filtermode: 'range', datafield: 'take_in', width: '8%', cellclassname: '', },
          { text: 'Airport Origin', filtertype: 'input', datafield: 'airport_origin', width: '8%', cellclassname: '', },
          { text: 'Expected Pcs', filtertype: 'input', datafield: 'expected_pieces', width: '8%', cellclassname: '', },
          { text: 'Expected Weight', filtertype: 'input', datafield: 'expected_weight', width: '8%', cellclassname: '', },
          {
            text: 'Accepted Pcs', filterable: false, datafield: 'accepted_pcs', width: '8%',
            cellclassname: (row, column, value, rowData, cellvalue) => {
              // console.log("🚀 ~ useEffect ~ rowData:", rowData)
              if (rowData.acceptedBorderColor == 'green') {
                return "awb_green";
              } else if (rowData.acceptedBorderColor == 'red') {
                return "awb_red";
              } else if (rowData.acceptedBorderColor == 'orange') {
                return "awb_orange";
              } else if (rowData.acceptedBorderColor == 'grey') {
                return "awb_blue";
              } else {
                return;
              }
            },
          },
          { text: 'Pcs Stock', filtertype: 'input', datafield: 'pcs_stock', width: '6%', cellclassname: '', },
          { text: 'In Release', filtertype: 'input', datafield: 'released_pcs', width: '6%', cellclassname: 'pcs-release-cell', },
          { text: 'Pcs Picked', filtertype: 'input', datafield: 'pieces_picked', width: '6%', cellclassname: 'pcs-picked-cell', },
          { text: "Pcs Delivered", filtertype: "input", datafield: "total_deliver_pcs", width: "8%", cellclassname: "pcs-deliver-cell", },
          // {
          //   text: 'Picked', filterable: false, datafield: 'picked', width: '8%',
          //   cellclassname: (row, column, value, rowData, cellvalue) => {
          //     // console.log("🚀 ~ useEffect ~ rowData:", rowData)
          //     if (rowData.pickedBorderColor == 'green') {
          //       return "awb_green";
          //     } else if (rowData.pickedBorderColor == 'red') {
          //       return "awb_red";
          //     } else if (rowData.pickedBorderColor == 'orange') {
          //       return "awb_orange";
          //     } else if (rowData.pickedBorderColor == 'grey') {
          //       return "awb_blue";
          //     } else {
          //       return;
          //     }
          //   },
          // },
          {
            text: 'Delivered', filterable: false, datafield: 'delivered', width: '6%',
            cellclassname: (row, column, value, rowData, cellvalue) => {
              // console.log("🚀 ~ useEffect ~ rowData:", rowData)
              if (rowData.deliveredBorderColor == 'green') {
                return "awb_green";
              } else if (rowData.deliveredBorderColor == 'red') {
                return "awb_red";
              } else if (rowData.deliveredBorderColor == 'orange') {
                return "awb_orange";
              } else if (rowData.deliveredBorderColor == 'grey') {
                return "awb_blue";
              } else {
                return;
              }
            },
          },
          { text: 'Consignee Name', filtertype: 'input', datafield: 'consignee_name', width: '8%', cellclassname: '', },
          { text: 'Release Status', filtertype: 'input', datafield: 'status', width: '8%', cellclassname: '', },
          // { text: 'Trucking Company', filtertype: 'textbox', datafield: 'trucking_company', width: '8%', cellclassname: '', },
        ];
      } else {
        columns = [
          { text: 'Release Number', filtertype: 'input', datafield: 'release_number', width: '8%', cellclassname: '', },
          { text: 'House AWB', filtertype: 'input', datafield: 'house_awb', width: '8%', cellclassname: '', },
          { text: 'Master AWB', filterable: 'input', datafield: 'master_awb', width: '6%', cellclassname: '', },
          { text: 'Take In', filtertype: 'range', cellsformat: 'dd-MM-yyyy', filtermode: 'range', datafield: 'take_in', width: '8%', cellclassname: '', },
          // {
          //   text: 'Acceptance', filterable: false, datafield: 'acceptance', width: '8%', cellclassname: '',
          //   cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
          //     if (cellValue) { //  + process.env.REACT_APP_BASE_URL_IMAGE + 'TruckMonitor/'
          //       defaultHtml = "<div style='text-align: center;line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
          //     }
          //     return (
          //       defaultHtml
          //     );
          //   },
          // },
          { text: 'Expected Pcs', filtertype: 'input', datafield: 'expected_pcs', width: '6%', cellclassname: '', },
          { text: 'Expected Weight', filtertype: 'input', datafield: 'expected_weight', width: '6%', cellclassname: '', },
          { text: 'Accepted Pcs', filterable: false, datafield: 'accepted_pcs', width: '8%', cellclassname: '', },
          { text: 'Pcs Stock', filtertype: 'input', datafield: 'pcs_stock', width: '6%', cellclassname: '', },
          {
            text: 'In Release', filtertype: 'input', datafield: 'released_pcs', width: '6%',
            cellclassname: (row, column, value, rowData, cellvalue) => {
              // console.log("🚀 ~ useEffect ~ rowData:", rowData)
              if (rowData.released_pcs) {
                return "awb_orange";
              } else {
                return;
              }
            },
          },
          { text: 'Pcs Picked', filtertype: 'input', datafield: 'pieces_picked', width: '6%', cellclassname: '', },
          { text: "Delivery Pcs", datafield: "delivery_pcs", width: "6%" },
          {
            text: 'Picklist Pdf', filterable: false, datafield: 'picklist_pdf', width: '8%', cellclassname: '',
            cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
              if (cellValue) { //  + process.env.REACT_APP_BASE_URL_IMAGE + 'TruckMonitor/'
                defaultHtml = "<div style='text-align: center;line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
              }
              return (
                defaultHtml
              );
            },
          },

          // {
          //   text: 'Set Delivered', filtertype: 'textbox', width: '8%', cellclassname: '', datafield: 'delivery_status',
          //   cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, data) {
          //     // defaultHtml = "<div style='text-align: center;line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
          //     //{console.log('rowData',rowdata);}
          //     //  if(cellValue != null){
          //      return defaultHtml = '<div class="set_fn screen"><span class=""><img src="' + pen + '" class="" /> Set</span></div>';
          //     // }
          //     // return (
          //     //   defaultHtml
          //     // );
          //   },
          // },
          { text: 'Trucking Company', filtertype: 'input', datafield: 'trucking_company', width: '8%', cellclassname: '', },
          {
            text: 'Release', filtertype: 'checkedlist', datafield: 'release', width: '8%',
            filteritems: [
              { label: 'Open', value: 'Open' },
              { label: 'Progress', value: 'Progress' },
              { label: 'Complete', value: 'Complete' },
              { label: 'Incomplete', value: 'Incomplete' },
            ],
            cellclassname: (row, column, value, rowData, cellvalue) => {
              // console.log("🚀 ~ useEffect ~ rowData:", rowData)
              if (rowData.release == 'Completed') {
                return "awb_green";
              } else if (rowData.release == 'Incomplete') {
                return "awb_red";
              } else if (rowData.release == 'Progress') {
                return "awb_orange";
              } else if (rowData.release == 'Open') {
                return "awb_blue";
              } else if (rowData.release == 'Initiated') {
                return "awb_sky";
              } else {
                return;
              }
            },
          },
        ];
      }
      // Nested ULD Start
      let nestedColumns = [
        { text: 'Release Number', filtertype: 'input', datafield: 'release_number', width: '8%', cellclassname: '', },
        { text: 'House AWB', filtertype: 'input', datafield: 'house_awb', width: '8%', cellclassname: '', },
        //{ text: 'Master AWB', filterable: 'textbox', datafield: 'master_awb', width: '6%', cellclassname: '', },
        //{ text: 'Take In', filtertype: 'range', cellsformat: 'dd-MM-yyyy', filtermode: 'range', datafield: 'take_in', width: '8%', cellclassname: '', },
        // {
        //   text: 'Acceptance', filterable: false, datafield: 'acceptance', width: '8%', cellclassname: '',
        //   cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
        //     if (cellValue) { //  + process.env.REACT_APP_BASE_URL_IMAGE + 'TruckMonitor/'
        //       defaultHtml = "<div style='text-align: center;line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
        //     }
        //     return (
        //       defaultHtml
        //     );
        //   },
        // },
        { text: 'Expected Pcs', filtertype: 'input', datafield: 'expected_pcs', width: '6%', cellclassname: '', },
        { text: 'Expected Weight', filtertype: 'input', datafield: 'expected_weight', width: '6%', cellclassname: '', },
        { text: 'Accepted Pcs', filterable: false, datafield: 'accepted_pcs', width: '8%', cellclassname: '', },
        { text: 'Pcs Stock', filtertype: 'input', datafield: 'pcs_stock', width: '6%', cellclassname: '', },
        {
          text: 'In Release', filtertype: 'input', datafield: 'released_pcs', width: '6%',
          cellclassname: (row, column, value, rowData, cellvalue) => {
            // console.log("🚀 ~ useEffect ~ rowData:", rowData)
            if (rowData.released_pcs) {
              return "awb_orange";
            } else {
              return;
            }
          },
        },
        { text: 'Pcs Picked', filtertype: 'input', datafield: 'pieces_picked', width: '7%', cellclassname: '', },
        {
          text: 'Picklist Pdf', filterable: false, datafield: 'picklist', width: '8%', cellclassname: '',
          cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
            if (cellValue) { //  + process.env.REACT_APP_BASE_URL_IMAGE + 'TruckMonitor/'
              defaultHtml = "<div style='text-align: center;line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
            }
            return (
              defaultHtml
            );
          },
        },
        { text: "Delivery Pcs", datafield: "delivery_pcs", width: "8%" },

        // {
        //   text: 'Set Delivered', filtertype: 'textbox', width: '8%', cellclassname: '', datafield: 'delivery_status',
        //   cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, data) {
        //     // defaultHtml = "<div style='text-align: center;line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
        //     //{console.log('rowData',rowdata);}
        //     //  if(cellValue != null){
        //      return defaultHtml = '<div class="set_fn screen"><span class=""><img src="' + pen + '" class="" /> Set</span></div>';
        //     // }
        //     // return (
        //     //   defaultHtml
        //     // );
        //   },
        // },
        { text: 'Trucking Company', filtertype: 'input', datafield: 'trucking_company', width: '8%', cellclassname: '', },
        {
          text: 'Release', filtertype: 'checkedlist', datafield: 'pick_status', width: '8%',
          filteritems: [
            { label: 'Open', value: 'Open' },
            { label: 'Progress', value: 'Progress' },
            { label: 'Complete', value: 'Complete' },
            { label: 'Incomplete', value: 'Incompleted' },
          ],
          cellclassname: (row, column, value, rowData, cellvalue) => {
            // console.log("🚀 ~ useEffect ~ rowData:", rowData)
            if (rowData.pick_status == 'Completed') {
              return "awb_green";
            } else if (rowData.pick_status == 'Incompleted') {
              return "awb_red";
            } else if (rowData.pick_status == 'Progress') {
              return "awb_orange";
            } else if (rowData.pick_status == 'Open') {
              return "awb_blue";
            } else if (rowData.pick_status == 'Initiated') {
              return "awb_sky";
            } else {
              return;
            }
          },
        },
      ];

      const nestedGrids = {};
      const initrowdetails = (index, parentElement, gridElement, record) => {
        const nestedGridContainer = parentElement.children[0];
        // console.log('Nested arrow clicked:', index, parentElement, gridElement, record);

        const parentRowId = record.uid.toString();
        nestedGrids[parentRowId] = nestedGridContainer;

        parentElement.addEventListener('click', (event) => {
          const target = event.target;
          // Check if the click target is the nested arrow
          if (window.$(target).hasClass('jqx-icon-arrow-right')) {
            // Handle nested arrow click here
            // console.log('Nested arrow clicked:', record);
            event.stopPropagation(); // Prevent event bubbling to the row details
          }
        });
        // console.log(dataAdapter);
        const id = record.uid.toString();
        // console.log('ov >>:', dataAdapter.loadedData.Rows[id]);
        const uldGrid = dataAdapter.loadedData.Rows[id].cargoid;
        const hawbGrid = dataAdapter.loadedData.Rows[id].hawb_id;
        let subendPoint = `shipment/release-sub-mawb?cargoid=${uldGrid}`;
        // if (activeTab == 'Active') { subendPoint = `shipment/sub-mawb?cargoid=${uldGrid}` } else { subendPoint = `shipment/sub-hawb?hawb_id=${hawbGrid}` }
        const nestedSource = {
          datatype: 'json',
          id: 'shipmentChildID',
          datafields: [
            { name: 'id', type: 'number' },
            { name: 'acceptance_id', type: 'number' },
            { name: 'hawbid', type: 'number' },
            { name: 'release_date', type: 'string' },
            { name: 'pcs_stock', type: 'number' },
            { name: 'released_pcs', type: 'number' },
            { name: 'actual_hawb_weight', type: 'string' },
            { name: 'house_awb', type: 'string' },
            { name: 'pieces_picked', type: 'number' },
            { name: 'total_weight', type: 'number' },
            { name: 'max_length', type: 'string' },
            { name: 'max_width', type: 'string' },
            { name: 'max_height', type: 'string' },
            { name: 'pick_status', type: 'string' },
            { name: 'pickStatusBorderColor', type: 'string' },
            { name: 'delivery_receipt', type: 'string' },
            { name: 'acceptance', type: 'string' },
            { name: 'picklist', type: 'string' },
            { name: 'delivery_status', type: 'string' },
            { name: 'deliveryBorderColor', type: 'string' },
            { name: 'expected_pcs', type: 'number' },
            { name: 'expected_weight', type: 'string' },
            { name: 'accepted_pcs', type: 'string' },
            { name: 'acceptedBorderColor', type: 'string' },
            { name: 'trucking_company', type: 'string' },
            { name: 'release_number', type: 'string' },
            { name: 'delivery_pcs', type: 'string' },
            { name: 'import_shipment_record_id', type: 'string' },
          ],
          // localdata: uldGrid,
          url: `${process.env.REACT_APP_RFS_URL}${subendPoint}`,
          // beforeSend: function (jqXHR) {
          //   jqXHR.setRequestHeader('Authorization', token);
          // },
          // localdata: gridData[activeTab],
          pagesize: 50,
          filter: function (allfilters) {
            if (allfilters.length > 0) {
              setFilterApplied(true);
              filterForCheck = true;
            } else {
              setFilterApplied(false);
              filterForCheck = false;
            }
            window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
            window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");


            // setTimeout(() => {
            //     const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');

            //     console.log("rows", rows);
            //     (checkUlds).forEach(uldNumber => {
            //         console.log(checkUlds);
            //         rows.forEach((element, index) => {
            //             if (element.uld_number == uldNumber) {
            //                 window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
            //             }
            //         });
            //     });
            // }, 4000);
          },
          beforeprocessing: function (data) {
            source.totalrecords = data.TotalRows;
            setTotalRows({ totalUlds: data.activeCount });
            setTotalRowsR({ totalUlds: data.archiveCount });
          },
          sort: function () {
            window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
          },
          root: "Rows",
          cache: false,
        }

        const nestedDataAdapter = new window.$.jqx.dataAdapter(nestedSource);

        const nestedGridOptions = {
          width: '100%',
          pageable: false,
          sortable: false,
          // pageSize: 15,
          autoheight: false,
          height: (10 * 45),
          selectionmode: '', // checkbox
          source: nestedDataAdapter,
          filterable: false,
          columns: nestedColumns,
          rowdetails: false,
          rowsheight: 45,
          showemptyrow: false,
          ready: function () {
            // Manually set row IDs starting from 0
            const rows = window.$(nestedGridContainer).jqxGrid('getrows');
            for (let i = 0; i < rows.length; i++) {
              const rowid = i; // Use index as the new row ID
              const row = rows[i];
              window.$(nestedGridContainer).jqxGrid('setcellvalue', row.uid, 'uid', rowid);
              window.$(nestedGridContainer).jqxGrid('updaterow', rowid, row);
              window.$(nestedGridContainer).find(`[role="row"][row-id="${row.uid}"]`).attr('row-id', rowid);
            }
          },
        };
        window.$(nestedGridContainer).jqxGrid(nestedGridOptions);
        window.$(nestedGridContainer).off("cellclick");
        window.$(nestedGridContainer).on("cellclick", (event) => {
          const args = event.args.row.bounddata;
          // console.log("🚀 ~ initrowdetails ~ args:", args)

          if (event.args.columnindex > 0 && event.args.columnindex !== 2 && event.args.columnindex !== 9) {
            if (gridSelect) {
              gridSelect.forEach((item) => {
                const selectedRowBoundIndex = item.boundindex;
                window.$(nestedGridContainer).jqxGrid("unselectrow", selectedRowBoundIndex);
              });
            }
            // loadHAWB(args.cargoid);
            loadHawbDetails(args);
            // setSelectedRowData(args);
            // setTimeout(() => {
            //   window.$(nestedGridContainer).jqxGrid("refresh");
            // }, 30);
          }
        });
      };
      // Nested End

      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        columns: columns,
        autoheight: false,
        height: 1040,
        sortable: true,
        altrows: false,
        columnsresize: false,
        enabletooltips: false,
        editable: false,
        selectionmode: 'checkbox',
        pageable: true,
        pageSize: 20,
        initrowdetails: activeTab === 'Active' ? initrowdetails : undefined,
        pagesizeoptions: ['50', '100', '200', '500'],
        pagerButtonsCount: 5,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 42,
        columnsheight: 45,
        showstatusbar: true,
        virtualmode: true,
        rendergridrows: function (params) {
          return params.data;
        },
        rowdetails: activeTab === 'Active' ? true : false,
        rowdetailstemplate: activeTab === 'Active' ? {
          rowdetails: '<div id="nestedGrid" style="margin: 10px;"></div>',
          rowdetailsheight: (10 * 45),
          rowdetailshidden: true,
        } : undefined,
        // rendered: function () {
        //   const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
        //   (checkUlds).forEach(uldNumber => {
        //     rows.forEach((element, index) => {
        //       if (element.uld_number == uldNumber) {
        //         window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
        //       }
        //     });
        //   });
        // }
      };
      window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
      window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');
      window.$(gridRefs[activeTab].current).on('click', '.row_edit', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
        const dataToSend = {
          uld_number: rowData.uld_number,
          type_code: rowData.type_code,
          serial_number: rowData.serial_number,
          owner_code: rowData.owner_code,
          condition_code: rowData.condition_code,
          asset_type: rowData.asset_type == 'Y' ? false : true
        };
        // setEditData(dataToSend);
        // setShowEdit(true);
      });
      window.$(gridRefs[activeTab].current).on('click', '.screen', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
        // console.log("🚀 ~ rowData:", rowData)
        // setIsModal(true)
      });
      window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
        window.$(row).on('mouseover', () => {
          window.$(row).addClass('row-hover');
        });
        window.$(row).on('mouseout', () => {
          window.$(row).removeClass('row-hover');
        });
      });
      // window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
      //   if (event.args.row) {
      //     const selectedRow = event.args.row;
      //     // console.log("🚀 ~ window.$ ~ selectedRow:", selectedRow)
      //     const uldNumber = selectedRow.cargoid;
      //     const selectedRowId = selectedRow.uid;
      //     if (!checkUlds.includes(uldNumber)) {
      //       checkUlds.push(uldNumber);
      //     }
      //     // console.log(checkUlds);
      //     // if (!gridSelect.some(row => row.cargoid === uldNumber)) {
      //     //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
      //     // }
      //     setGridSelect(prevGridSelect => {
      //       if (!prevGridSelect.some(row => row.cargoid === uldNumber)) {
      //         return [...prevGridSelect, selectedRow];
      //       }
      //       return prevGridSelect;
      //     });
      //   } else {
      //     if (event.args.rowindex.length > 0) {
      //       const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
      //       setGridSelect(allIds);
      //     } else {
      //       setGridSelect([]);
      //     }
      //   }
      // });
      window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
        if (event.args.row) {
          const selectedRow = event.args.row;
          const identifier = activeTab === 'Active' ? selectedRow.cargoid : selectedRow.id;
          const selectedRowId = selectedRow.uid;

          if (!checkUlds.includes(identifier)) {
            checkUlds.push(identifier);
          }

          // console.log("🚀 ~ checkUlds:", checkUlds);

          setGridSelect(prevGridSelect => {
            const exists = activeTab === 'Active'
              ? prevGridSelect.some(row => row.cargoid === identifier)
              : prevGridSelect.some(row => row.id === identifier);

            if (!exists) {
              const newSelection = [...prevGridSelect, selectedRow];
              return newSelection;
            }
            return prevGridSelect;
          });
        } else {
          if (event.args.rowindex.length > 0) {
            const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
            setGridSelect(allIds);
          } else {
            setGridSelect([]);
          }
        }
      });
      // window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
      //   if (event.args.row) {
      //     const unselectedRowId = event.args.row.cargoid;
      //     setGridSelect(prevSelection => prevSelection.filter(row => row.cargoid !== unselectedRowId));
      //     // if(filterForCheck!=true){
      //     if (!checkUlds.includes(unselectedRowId)) {
      //       checkUlds.push(unselectedRowId);
      //     } else {
      //       checkUlds = checkUlds.filter(item => item !== unselectedRowId);
      //     }
      //     // }
      //     // console.log(checkUlds);

      //   }
      // });
      window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
        if (event.args.row) {
          // Use different identifiers based on the active tab
          const unselectedRowId = activeTab === 'Active' ? event.args.row.cargoid : event.args.row.id;

          // Filter out the unselected row using the appropriate identifier
          setGridSelect(prevSelection => {
            return activeTab === 'Active'
              ? prevSelection.filter(row => row.cargoid !== unselectedRowId)
              : prevSelection.filter(row => row.id !== unselectedRowId);
          });

          // Update checkUlds array
          if (!checkUlds.includes(unselectedRowId)) {
            checkUlds.push(unselectedRowId);
          } else {
            checkUlds = checkUlds.filter(item => item !== unselectedRowId);
          }

          // console.log("🚀 ~ rowunselect ~ checkUlds:", checkUlds); // Debug log
        }
      });
      window.$(gridRefs[activeTab].current).off('cellclick');
      window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
        const args = event.args.row.bounddata;
        if (activeTab == 'Active') {
          if (event.args.columnindex > 1) {
            if (gridSelect) {
              gridSelect.forEach(item => {
                const selectedRowBoundIndex = item.boundindex;
                window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
              });
            }
            loadHAWB(args.cargoid);
            // loadDetails(args.uld_number);
            loadMawbDetails(args);
            setSelectedRowData(args)
            setTimeout(() => {
              window.$(gridRefs[activeTab].current).jqxGrid('refresh');
            }, 30);
          }
        } else {
          if (event.args.columnindex > 1 && event.args.columnindex !== 12) {
            if (gridSelect) {
              gridSelect.forEach(item => {
                const selectedRowBoundIndex = item.boundindex;
                window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
              });
            }
            // loadDetails(args.uld_number);
            setSelectedRowData(args)
            setTimeout(() => {
              window.$(gridRefs[activeTab].current).jqxGrid('refresh');
            }, 30);
          }
        }

      });
      // }
    }
  }, [gridData]);
  const loadDetails = async (id) => {
    if (id == null) {
      toast.error("Old Data. Data not viewable.");
      return;
    }
    localStorage.removeItem('SHEdit');
    localStorage.setItem('SHEdit', JSON.stringify(id));
    localStorage.setItem('ccbackUrl', '/ForwarderShipments/Import');
    localStorage.setItem('AddShipmentType', 'release');
    history.push('/ForwarderShipments/AddShipmentRecords');
  };

  const handleCloseClick = () => {
    setSelectedRowData(null);
    setTimeout(() => {
      window.$(gridRefs[activeTab].current).jqxGrid('refresh');
    }, 30);
  };
  // upload Section
  const [showModalUpload, setShowModalUpload] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);
  const [base64Files, setBase64Files] = useState([]);

  // const imageModalUpload = (id) => {
  //     setSelectedRowId(id);
  //     setShowModalUpload(true)
  //     setFiles([])
  // }
  const imageModalUpload = (id) => {
    const selectedRowFiles = gridSelect.find(item => item.uid === id)?.files || [];
    setFiles(selectedRowFiles);
    setSelectedRowId(id); // Store the ID of the selected row
    setShowModalUpload(true);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    getBase64(droppedFiles[0]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDeleteFile = (index) => {
    setFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles.splice(index, 1);
      return newFiles;
    });
    base64Files.splice(index, 1);
  };

  const handleBrowseFiles = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  // const handleFileChange = (e) => {
  //     const selectedFiles = Array.from(e.target.files);
  //     const filesWithBase64 = [];
  //     selectedFiles.forEach((file) => {
  //         const reader = new FileReader();
  //         reader.onloadend = () => {
  //             filesWithBase64.push({ file, base64: reader.result });
  //             if (filesWithBase64.length === selectedFiles.length) {
  //                 setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => obj.file)]);

  //             }
  //         };
  //         reader.readAsDataURL(file);
  //     });
  // }
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const filesWithBase64 = [];

    selectedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        filesWithBase64.push({ "base64": reader.result, "file_name": file.name });

        if (filesWithBase64.length === selectedFiles.length) {
          setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
          setBase64Files((prevBase64Files) => [...prevBase64Files, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
        }
      };
      reader.readAsDataURL(file);
    });
  };
  const imageUpload = () => {
    setGridSelect(prevGridSelect =>
      prevGridSelect.map(item => {
        if (item.uid === selectedRowId) {
          return { ...item, files: files, base64Files: base64Files };
        }
        return item;
      })
    );
    setShowModalUpload(false);
  };
  // upload forward
  const imageUploadRef = useRef(null);
  const browseClick = () => {
    if (imageUploadRef.current) {
      imageUploadRef.current.handleBrowseFiles();
    }
  };
  // +++++++++++++++++++++++++++++++++++ Silk Slider
  const findPrimary = selectedRowData?.attachments?.filter((attachment) => attachment.primary === 1);
  const [show, setShow] = useState(false);
  const [selectedFile, setSelectedFile] = useState('');

  const handleFileClick = (file) => {
    setSelectedFile(file);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setSelectedFile('');
  };

  const changeModalInfo = () => {
    if (modalType === 'C') {
      setModalType('T');
      // setModalData({}); // Only clear when going to 'T'
    } else {
      setModalType('C');
      // Do NOT clear modalData here, so hawb_details is preserved
    }
  }

  const releaseChange = (idx, name, value) => {
    if (name == 'released_pcs') {
      const updatedGroups = [...modalData.hawb_details];
      updatedGroups[idx][name] = value;
      setModalData({ ...modalData, hawb_details: updatedGroups });
    } else {
      setModalData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  }

  const validateReleaseForm = () => {
    const errors = [];

    // if (!modalData?.name || modalData.name.trim() === '') {
    //   errors.push('Name is required');
    // }
    if (!modalData?.hawb_details || modalData.hawb_details.length === 0) {
      errors.push('HAWB details are required');
    } else {
      modalData.hawb_details.forEach((group, idx) => {
        const hawbNumber = group.hawb || `HAWB ${idx + 1}`;





        // if (!group.released_pcs || group.released_pcs.toString().trim() === '') {
        //   errors.push(`Released Pieces is required for ${hawbNumber}`);
        // }


        // if (group.picked_pcs && group.released_pcs) {
        //   const pickedPcs = parseInt(group.picked_pcs) || 0;
        //   const releasedPcs = parseInt(group.released_pcs) || 0;

        //   if (releasedPcs > pickedPcs) {
        //     errors.push(`Released Pieces cannot exceed Picked Pieces for ${hawbNumber}`);
        //   }
        // }


        if (group.is_deliver == '1') {
          if (!group.picked_pcs || group.picked_pcs.toString().trim() === '') {
            errors.push(`Picked Pieces is required for ${hawbNumber}`);
          }
          if (!group.delivered_pcs || group.delivered_pcs.toString().trim() === '') {
            errors.push(`Delivery Pieces is required for ${hawbNumber} (marked as delivered)`);
          }
          if (!group.name || group.name.toString().trim() === '') {
            errors.push(`Name is required for ${hawbNumber}`);
          }

          // if (group.picked_pcs && group.delivered_pcs) {
          //   const pickedPcs = parseInt(group.picked_pcs) || 0;
          //   const deliveredPcs = parseInt(group.delivered_pcs) || 0;

          //   if (deliveredPcs !== pickedPcs) {
          //     errors.push(`Delivery Pieces should match Picked Pieces for ${hawbNumber}`);
          //   }
          // }
          // Add required checks for Warehouse Out, Doc Type, and DOC No when switchData is true
          if (switchData) {
            if (!group.warehouse_out?.toString().trim())
              errors.push(`Warehouse Out is required for ${hawbNumber}`);
            if (!group.warehouse_out_doc_type?.toString().trim())
              errors.push(`Doc Type is required for ${hawbNumber}`);
            // if (!group.warehouse_out_doc_no?.toString().trim())
            //   errors.push(`DOC No is required for ${hawbNumber}`);
            if (group.warehouse_out_doc_type !== 'Transfer') {
              if (!group.warehouse_out_doc_no || group.warehouse_out_doc_no === "") {
                errors.push(`DOC No is required for ${hawbNumber}`);
                return false;
              }
            }
          }
        }
      });
    }

    return errors;
  };

  const handleRelease = async () => {
    const validationErrors = validateReleaseForm();

    if (validationErrors.length > 0) {
      toast.error(validationErrors[0]);
      return; // Stop execution if validation fails
    }

    const cid = gridSelect?.map(cd => cd.cargoid);
    let filteredHawbDetails = modalData.hawb_details.map((item, idx) => {
      const { actual_pcs_snapshot, ...rest } = item; // Remove snapshot from payload
      if (item.is_deliver === "0") {
        const { delivered_pcs, hawb, hawb_id, ...rest2 } = rest;
        // For Archived tab, add id from gridSelect
        if (activeTab === 'Archived') {
          // Try to get the id from the item itself, fallback to gridSelect[idx]
          let id = item.id || (gridSelect[idx] && (gridSelect[idx].id || gridSelect[idx].hawb_id));
          return { ...rest2, id };
        }
        return { ...rest2 };
      }
      // For is_deliver === '1'
      const { hawb_id, ...rest2 } = rest;
      if (activeTab === 'Archived') {
        let id = item.id || (gridSelect[idx] && (gridSelect[idx].id || gridSelect[idx].hawb_id));
        return { ...rest2, id };
      }
      return { ...rest2 };
    });
    const payload = {
      ...modalData,
      hawb_details: filteredHawbDetails,
      cargoid: cid,
      tabType: activeTab === 'Active' ? 'MAWB' : 'HAWB'
    };
    // console.log('payload', payload);

    try {
      const res = await withRFSToken.post('shipment/move-to-delivered', payload)
        .then(function (res) {
          if (res.data.response_code != 200) {
            toast.error(res.data.response_msg);
            return;
          }
          const innerData = res.data.response_data;
          // console.log("🚀 ~ .then ~ innerData:654", innerData)
          //setSelectedRowData(innerData);
          setIsModal(false);
          toast.success(res.data.response_msg);
          window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
          gridSelect.forEach(item => {
            const selectedRowBoundIndex = item.boundindex;
            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
          });
          setGridSelect([]);
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const isModalClose = () => {
    setIsModal(false);
  }

  const resetFilters = () => {
    window.$(gridRefs[activeTab].current).jqxGrid('clearfilters');
    // gridSelect.forEach(item => {
    //     const selectedRowBoundIndex = item.boundindex;
    //     window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
    // });
    // setGridSelect([]);
  };

  const createCargo = () => {
    localStorage.setItem('ccbackUrl', '/ForwarderShipments/Import');
    history.push('/ForwarderShipments/CreateCargo');
  };

  const [truckerData, setTruckerData] = useState({});

  const handleTruckerInputChange = (eOrKey, value) => {
    if (eOrKey && eOrKey.target) {
      const { name, value } = eOrKey.target;
      setTruckerData(prev => ({ ...prev, [name]: value }));
    }
    else if (typeof eOrKey === 'string') {
      setTruckerData(prev => ({ ...prev, [eOrKey]: value }));
    }
  };

  const handleSaveTrucker = async () => {
    try {
      const { data } = await withRFSToken.post('address-book/add-update', truckerData);

      if (data.response_code === 200) {
        toast.success(data.response_msg || 'Trucker saved successfully.');
        setModalType('C');
        loadCompany();
      } else {
        toast.error(data.response_msg || 'Unable to save trucker.');
      }
    } catch (error) {
      toast.error('An unexpected error occurred while saving the trucker.');
      console.error('Save Trucker Error:', error);
    }
  };

  useEffect(() => {
    if (isModal && modalData && modalData.hawb_details) {
      setModalData(prev => ({
        ...prev,
        hawb_details: prev.hawb_details.map(group => ({
          ...group,
          actual_pcs_snapshot: group.actual_pcs_snapshot
        }))
      }));
    }
  }, [isModal]);

  const validatePieces = (deliveryValue, pickedPieces) => {
    const deliveryNum = parseInt(deliveryValue) || 0;
    const pickedNum = parseInt(pickedPieces) || 0;

    if (deliveryNum > pickedNum) {
      return `Cannot exceed ${pickedNum} pieces`;
    }
    if (deliveryNum < 0) {
      return 'Cannot be negative';
    }
    return '';
  }

  const handleDownload = async () => {
    try {
      let ids = [];
      let tabName = '';

      if (activeTab === 'Active') {
        tabName = 'ReleaseMAWB';
        ids = gridSelect?.map(data => data.cargoid) || [];
      } else if (activeTab === 'Archived') {
        tabName = 'Release';
        ids = gridSelect?.map(data => data.id) || [];
      }

      const payload = {
        tab_name: tabName,
        fields: '',
        ids: ids,
        status: ''
      };

      const res = await withRFSToken.post('shipment/download-import-shipment', payload, {
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${tabName}_${new Date().getTime()}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success('Downloaded successfully');
      setGridSelect([]);
      window.$(gridRefs[activeTab].current).jqxGrid("clearselection");
      window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
    } catch (error) {
      console.error('Error downloading data:', error);
      toast.error('Failed to download data');
    }
  };

  return (
    <>
    {/* {console.log("gridselect", gridSelect)} */}

      <div className="mb-3 nestedtabs rounded minh">
        <div className='d-flex'>

          {/* <button className="addtruck me-2" variant="primary" onClick={createCargo}>
            <span> <FontAwesomeIcon icon={faPlus} />  Create Cargo</span>
          </button> */}
          {/* {console.log('gridSelect', gridSelect)}
          <button className="addtruck me-2" variant="primary" onClick={() => handleDropdownItemClick('T', 'C')}>
            <span> <FontAwesomeIcon icon={faPlus} /> Add Shipment</span>
          </button> */}
          {/* <Dropdown>
            <Dropdown.Toggle variant="light" id="dropdown-basic" className='adduld'>
              <FontAwesomeIcon icon={faPlus} /> Add MAWB <FontAwesomeIcon icon={faChevronDown} />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => handleDropdownItemClick('T', 'C')}>Consolidated</Dropdown.Item>
              <Dropdown.Item onClick={() => handleDropdownItemClick('T', 'B')}>Back to Back</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown> */}
          <Dropdown>
            <Dropdown.Toggle variant="light" id="dropdown-basic" className='action'>
              <FontAwesomeIcon icon={faGear} /> Actions <FontAwesomeIcon icon={faChevronDown} />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'In Operation')}>Move to delivered</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
         <div className='ulddown'>
           <button onClick={handleDownload}>
             <img src={Export} alt="export" /> Download
           </button>
          </div>
        </div>
      </div>
      <div className="maindiv">
        <div className='trashdonload'>
          <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
            <Tab eventKey="Active" title={<span>Active MAWB<Badge className='rabadge'>{totalRows.totalUlds}</Badge></span>} className='moveto'>
              {/* <Loader isLoading={isLoading} /> */}
              {!isLoading && <>
                {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                <div ref={gridRefs.Active} className='bookinggrid' ></div>
              </>
              }
              {/* <div ref={gridRefs.Active} className='bookinggrid' ></div> */}
            </Tab>
            <Tab eventKey="Archived" title={<span>Active HAWB<Badge className='rabadge'>{totalRowsR.totalUlds}</Badge></span>} className='moveto'>
              {/* <Loader isLoading={isLoading} /> */}
              {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
              {!isLoading && <div ref={gridRefs.Archived} className='bookinggrid' ></div>}
              {/* <div ref={gridRefs.Archived} className='bookinggrid' ></div> */}
            </Tab>
          </Tabs>
        </div>
        {selectedRowData && (
          <div className='SecondDiv mt-45'>
            <button className='close' onClick={handleCloseClick}>
              <FontAwesomeIcon icon={faXmark} />
            </button>

            <div className='girddtals_header'>
              <h3>
                {activeTab == 'Active'
                  ? selectedRowData.master_airway_bill || selectedRowData.house_awb
                  : selectedRowData.house_awb}
                &nbsp; <span>{selectedRowData.status}</span>
              </h3>

              {/* Show Attach + Details only if not subMawb */}
              {subMawb ? (
                <></>
              ) : (
                <div className='d-flex actbtn justify-content-between'>
                  <Button variant="light" onClick={browseClick}>
                    <FontAwesomeIcon icon={faPaperclip} /> Attach
                  </Button>
                  {activeTab === 'Archived' && (
                    <div
                      className='viwall'
                      onClick={() => loadDetails(selectedRowData?.import_shipment_record_id)}
                    >
                      <Link to='#'>Details</Link>
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* MAIN BODY */}
            {subMawb ? (
              // Show mvtLog if subMawb
              <div className="mt-2">
                <h3>HAWB Information</h3>
                {selectedRowData?.mvtLog?.map((log, index) => (
                  <div key={index} className="hawb_pic_list">
                    <ul>
                      <li>
                        <p>
                          <span>Delivery Date : {log.moved_at.split(" ")[0]}</span>
                          <span>Delivery Time : {log.moved_at.split(" ")[1]}</span>
                        </p>
                      </li>
                      <li>
                        {log.stage !== 'in_stock' && (
                          <span>Pcs Picked : {log.picked_pcs}</span>
                        )}
                        <span>
                          {log.stage === 'in_stock' ? "Accepted Pcs" : "Delivered Pcs"} : {log.pieces_moved}
                        </span>
                        <span>Stage : {log.stage}</span>
                        {log.import_delivery_pdf && (
                          <span>
                            Pdf :{" "}
                            <a href={log.import_delivery_pdf}
                              target="_blank"
                              rel="noopener noreferrer">
                              <img src={Rapdf} alt="PDF" style={{ width: "25px" }} />
                            </a>
                          </span>
                        )}
                      </li>
                    </ul>
                  </div>
                ))}
              </div>
            ) : (
              // Else show Highlighted Images + HAWB Details
              <div className='mt-3'>
                <div className='mb-3'>
                  {/* <h3>Highlighted Image(s)</h3>
          {selectedRowData?.attachments && (
            <div className='main_primary'>
              {findPrimary.map((file, index) => {
                const fileName = file?.file_name;
                const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                const extension = fileName?.split(".").pop();
                return (
                  <div key={`ns_${index}`} className='primary_image'>
                    {["jpeg", "jpg", "png", "webp"].includes(
                      file.file_path?.split(".").pop()
                    ) ? (
                      <div>
                        <img
                          src={file.file_path}
                          alt="Preview"
                          style={{ maxWidth: "100%", maxHeight: "100%" }}
                          onClick={() => handleFileClick(file.file_path)}
                        />
                      </div>
                    ) : (
                      <span>
                        <img src={Docmnt} className="fileimg" />
                      </span>
                    )}
                    <span className="rafilename">
                      {baseName?.length <= 5 ? fileName : `${baseName?.substring(0, 5)}... .${extension}`}
                    </span>
                  </div>
                );
              })}
            </div>
          )} */}
                </div>

                {activeTab === "Active" && (
                  <div>
                    <h3>HAWB Information</h3>
                    <ul className="hawb_type_info">
                      {modalData?.hawb_details?.map((hawbItem, index) => (
                        <li key={hawbItem.id || index}>
                          <span>HAWB ({hawbItem.hawb}) :</span>
                          <span
                            className="viwall"
                            onClick={() => loadDetails(hawbItem?.import_shipment_record_id)}
                          >
                            <Link to="#">Details</Link>
                          </span>
                        </li>
                      ))}
                    </ul>
                    <h3>Release Information</h3>
                    {selectedRowData?.mvtLog?.map((log, index) => (

                      <div key={index} className="hawb_pic_list">
                        <ul>
                          <li>
                            <p>
                              <span>Release Date : {log.moved_at.split(" ")[0]}</span>
                              <span>Release Time : {log.moved_at.split(" ")[1]}</span>
                            </p>
                          </li>
                          <li>
                            {log.stage !== 'in_stock' && (
                              <span>Pcs Picked : {log.picked_pcs}</span>
                            )}
                            <span>
                              Release Pcs : {log.pieces_moved}
                            </span>
                            <span>Stage : {log.stage}</span>
                            {log.import_delivery_pdf && (
                              <span>
                                Pdf :{" "}
                                <a href={log.import_delivery_pdf}
                                  target="_blank"
                                  rel="noopener noreferrer">
                                  <img src={Rapdf} alt="PDF" style={{ width: "25px" }} />
                                </a>
                              </span>
                            )}
                          </li>
                        </ul>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* COMMON FOOTER PART */}
            <ImageUpload
              ref={imageUploadRef}
              attachable_type={"uld"}
              attachable_id={selectedRowData.uld_number}
              attachments={selectedRowData.attachments}
              onDeleteSuccess={() => loadDetails(selectedRowData.uld_number)}
            />
            <ActivityComments
              commentable_type={"uld"}
              commentable_id={selectedRowData.uld_number}
              allactivities={selectedRowData.activities}
              onReloadDetails={loadDetails}
            />
          </div>
        )}

      </div>
      <Modal show={isModal} onHide={!isSaving ? isModalClose : null} className='addfrom change_type' centered>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <h3>Move to delivered</h3>
          {/* <p>If you proceed with the change, user data will be removed. <br /> Are you sure you want to continue? </p> */}
          <Link to='#' onClick={changeModalInfo} className='add_truck'>
            {modalType === 'C' ? <> <FontAwesomeIcon icon={faPlus} /> Add Customer</> : <> <FontAwesomeIcon icon={faArrowLeft} /> Back</>}
          </Link>
          {/* {console.log('modalData', modalData)} */}
          {modalType === 'C' ?
            <>
              <div className='saairbill mb-2'>
                <div>
                  <Form.Label>Customer Info</Form.Label>

                </div>
                <Select
                  options={companyOption}
                  placeholder="Condition Code"
                  className='down_selct'
                  onChange={(selected) => {
                    // const selectedValues = selected ? selected.map(option => option.value) : [];
                    setModalData({ ...modalData, company_name: selected.label, trucking_Id: selected.value });
                  }}
                  // isMulti
                  name="status"
                  value={companyOption?.find(value => value.value === modalData?.status)}
                />
              </div>
              {/* <div className='saairbill mb-2'>
                <Form.Label>Release By <span>*</span></Form.Label>
                <Form.Control
                  type="text" name='name'
                  value={modalData?.name || ''}
                  onChange={(e) => releaseChange('', 'name', e.target.value)}
                />
              </div> */}
              <div className='modal_from mt-3'>
                {/* <p></p> */}
                <Accordion defaultActiveKey="0" flush>
                  {modalData?.hawb_details?.map((group, idx) => (
                    <Accordion.Item eventKey={idx.toString()} key={idx}>
                      <Accordion.Header>HAWB {group.hawb}</Accordion.Header>
                      <Accordion.Body>
                        {/* <p>HAWB : {group.hawb}</p> */}
                        <ul className='relase_pic'>
                          <li><span>No Labels : {group.label}</span> <span>Pick Status : {group.pick_status}</span></li>
                          <li><span>Label : {group.label}</span> <span>Location : {group.location}</span></li>
                          <li><span>InStock Pieces : {group.actual_pcs_snapshot}</span>
                            <span>Picked List :
                              {group.picklist &&
                                <a target='_blank' href={group.picklist} rel="noopener noreferrer">
                                  <img style={{ width: '25px' }} src={Rapdf} alt="picklist" />
                                </a>
                              }
                            </span>

                          </li>
                          <li><span>Release Pieces : {group.r_pcs}</span> </li>

                        </ul>

                        <Form.Group as={Row} className="mb-2">
                          <Form.Label column sm="12">
                            Delivered to Consignee? <span className="text-danger"></span>
                          </Form.Label>
                          <Col sm="12">
                            <Form.Check
                              type="radio"
                              label="YES"
                              name={`is_deliver-${idx}`}
                              id={`piecesConfirmYes-${idx}`}
                              value="1"
                              checked={group.is_deliver == '1'}
                              onChange={e => handleGroupChange(idx, 'is_deliver', e.target.value, 'R')}
                              inline
                            />
                            {/* {console.log("group is deliver",group.is_deliver)} */}
                            <Form.Check
                              type="radio"
                              label="NO"
                              name={`is_deliver-${idx}`}
                              id={`piecesConfirmNo-${idx}`}
                              value="0"
                              checked={group.is_deliver == '0'}
                              onChange={e => handleGroupChange(idx, 'is_deliver', e.target.value, 'R')}
                              inline
                            />
                          </Col>
                        </Form.Group>




                        {group.is_deliver == '1' && <>

                          <Form.Group as={Row} className="mb-2">
                            <Col sm='6'>
                              <Form.Label>Picked Pieces<span className="text-danger">*</span></Form.Label>
                              <Form.Control
                                type="number" min="0" max={group?.actual_pcs_snapshot}
                                value={group.picked_pcs}
                                onChange={(e) => {
                                  const error = validatePieces(e.target.value, group?.actual_pcs_snapshot)
                                  if (!error) {
                                    handleGroupChange(idx, 'picked_pcs', e.target.value, 'R')
                                  }
                                  else {
                                    toast.error("Picked Pieces can't be greater than actual pieces")
                                  }
                                }

                                }
                              //placeholder={`Max: ${group?.actual_pcs_snapshot}`}
                              // disabled={group.is_deliver === '1'}
                              />
                            </Col>
                            <Col sm='6'>
                              <Form.Label>Delivery Pieces<span className="text-danger">*</span></Form.Label>
                              <Form.Control
                                type="number"
                                value={group.delivered_pcs} min="0"
                                max={group?.actual_pcs_snapshot}
                                onChange={(e) => {
                                  let error = validatePieces(e.target.value, group?.actual_pcs_snapshot)
                                  if (!error) {
                                    handleGroupChange(idx, 'delivered_pcs', e.target.value, 'R')
                                  }
                                  else {
                                    toast.error("Delivery Pieces can't be greater than actual pieces")
                                  }
                                }}
                              //placeholder={`Max: ${group?.actual_pcs_snapshot}`}
                              // disabled={group.piecesConfirm === 'YES'}
                              /></Col>
                            {/* <Col sm='6'>
                              <Form.Label>Released <span>*</span></Form.Label>
                              <Form.Control
                                type="number" name='released_pcs' min="0" max={group?.actual_pcs_snapshot}
                                value={group.released_pcs || ''}
                                onChange={(e) => {
                                   const error = validatePieces(e.target.value , group?.actual_pcs_snapshot)
                                   if(!error){
                                  releaseChange(idx, 'released_pcs', e.target.value)}}}
                                  placeholder={`Max: ${group?.actual_pcs_snapshot}`}
                              />
                            </Col> */}
                          </Form.Group>

                          <Form.Group as={Row} className="mb-2">
                            <Col sm='6'>
                              <Form.Label>Release By <span>*</span></Form.Label>
                              <Form.Control
                                type="text" name='name'
                                value={group?.name || ''}
                                onChange={(e) => handleGroupChange(idx, 'name', e.target.value, 'R')}
                              />
                            </Col>
                            <Col sm='6'>
                              <Form.Label>Warehouse Out  {switchData && <span className="text-danger">*</span>}</Form.Label>
                              <Form.Control
                                type="datetime-local"
                                value={group.warehouse_out}
                                onChange={e => handleGroupChange(idx, 'warehouse_out', e.target.value, 'R')}
                              // disabled={true}
                              />
                            </Col>
                          </Form.Group>

                          {group.warehouse_out_doc_type === 'Transfer' && (
                            <>
                              <Form.Group as={Row} className="mb-2">
                                <Col sm="12">
                                  <Form.Label>
                                    Doc Type : {switchData && <span className="text-danger">*</span>}
                                  </Form.Label>
                                  <Select
                                    options={acceptanceWarehouseInhandlerOptions}
                                    name="warehouse_out_doc_type"
                                    className="w-100 autoslct"
                                    value={
                                      acceptanceWarehouseInhandlerOptions.find(
                                        opt => opt.value === group.warehouse_out_doc_type
                                      ) || ''
                                    }
                                    onChange={e =>
                                      handleGroupChange(idx, 'warehouse_out_doc_type', e.value, 'R')
                                    }
                                  />
                                </Col>
                              </Form.Group>
                            </>
                          )}

                          {group.warehouse_out_doc_type !== 'Transfer' && (
                            <Form.Group as={Row} className="mb-2">
                              <Col sm="6">
                                <Form.Label>
                                  Doc Type : {switchData && <span className="text-danger">*</span>}
                                </Form.Label>
                                <Select
                                  options={acceptanceWarehouseInhandlerOptions}
                                  name="warehouse_out_doc_type"
                                  className="w-100 autoslct"
                                  value={
                                    acceptanceWarehouseInhandlerOptions.find(
                                      opt => opt.value === group.warehouse_out_doc_type
                                    ) || ''
                                  }
                                  onChange={e =>
                                    handleGroupChange(idx, 'warehouse_out_doc_type', e.value, 'R')
                                  }
                                />
                              </Col>
                              <Col sm="6">
                                <Form.Label>
                                  DOC No : {switchData && <span className="text-danger">*</span>}
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  value={group.warehouse_out_doc_no}
                                  onChange={e =>
                                    handleGroupChange(idx, 'warehouse_out_doc_no', e.target.value, 'R')
                                  }
                                />
                              </Col>
                            </Form.Group>
                          )}
                        </>}



                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion></div>
              {/* <div className='saairbill'>
                <Form.Label>Released <span>*</span></Form.Label>
                <Form.Control
                  type="text" name='company_name'
                  value={modalData.company_name || ''}                 
                  onChange={(e) => releaseChange('company_name', e.target.value)}
                />
              </div> */}
            </>
            :
            <>
              <h3>Add Customer:</h3>

              {/* Customer Name */}
              <div className='saairbill mb-2'>
                <Form.Label>Customer Name <span>*</span></Form.Label>
                <Form.Control
                  type="text"
                  name='name'
                  value={truckerData.name}
                  onChange={handleTruckerInputChange}
                />
              </div>

              {/* Customer Type */}
              <div className='saairbill mb-2'>
                <Form.Label>Customer Type <span>*</span></Form.Label>
                <Select
                  options={CustomerOptions}
                  onChange={(selected) => {
                    handleTruckerInputChange('customer_type', selected ? selected.value : '');
                  }}
                  placeholder="Customer"
                  className='rfs_autoslct'
                  name="customer_type"
                  value={CustomerOptions.find(option => option.value === truckerData.customer_type) || null}
                />
              </div>

              {/* Agent Code */}
              <div className='saairbill mb-2'>
                <Form.Label>Agent Code</Form.Label>
                <Form.Control
                  type="text"
                  name='agent_code'
                  value={truckerData.agent_code || ''}
                  onChange={handleTruckerInputChange}
                />
              </div>

              {/* Email */}
              <div className='saairbill mb-2'>
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="text"
                  name='email'
                  value={truckerData.email}
                  onChange={handleTruckerInputChange}
                />
              </div>

              {/* Mobile */}
              {/* <div className='saairbill mb-2'>
                <Form.Label>Mobile Number</Form.Label>
                <Form.Control
                  type="text"
                  name='number'
                  value={truckerData.number}
                  onChange={handleTruckerInputChange}
                />
              </div> */}

              {/* Airport Origin */}
              {/* <div className='saairbill mb-2'>
                <Form.Label>Airport Origin</Form.Label>
               <Select
                options={getDestination}
                onChange={(selected) => {
                  const selectedValues = selected ? selected.map(option => option.value) : [];
                  handleTruckerInputChange('airport_code', selectedValues);
                }}
                value={getDestination?.filter(opt => truckerData.airport_code?.includes(opt.value))}
                className="w-100"
                placeholder="Origin" 
                isMulti
              />
              </div> */}
              <div className='saairbill mb-2'>
                <Form.Label>Account Number</Form.Label>
                <Form.Control
                  type="text"
                  name='account_number'
                  value={truckerData.account_number}
                  onChange={handleTruckerInputChange}
                />
              </div>

              <div className='saairbill mb-2'>
                <Form.Label>Address</Form.Label>
                <Form.Control
                  type="text"
                  name='address'
                  value={truckerData.address}
                  onChange={handleTruckerInputChange}
                />
              </div>
            </>
          }
        </Modal.Body>
        <Modal.Footer>
          {/* <Button variant="danger" disabled={isSaving} className='position-relative' onClick={isModalClose}>
            Cancel
          </Button> */}
          {modalType === 'C' ?
            <>
              <Button variant="primary" disabled={isSaving} className='position-relative' onClick={handleRelease}>
                {isSaving ? <>Updating...<div className='mvt loader-container' style={{ height: 41 + 'px' }}><span className='mvt loader' style={{ top: 3 + 'px', left: 45 + '%' }}></span></div></> : 'Deliver'}
              </Button></>
            :
            <>
              <Button variant="primary" className='position-relative' onClick={handleSaveTrucker}>
                Save
              </Button>
            </>}
        </Modal.Footer>
      </Modal>
      <Modal show={mawbModal} onHide={closeModal} className='addfrom change_type' centered size={modalFor == 'C' ? 'xl' : ''}>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          {modalFor == 'C' &&
            <>
              <h3>Accept Shipment - Import (Consolidated)</h3>
              <Row className='mt-4'>
                <Col sm='6'>
                  <div className='missing_info modal_from'>
                    <h4>Shipment Information</h4>
                    <p></p>
                    <Form.Group as={Row} className="mb-2" controlId="exampleForm.ControlInput1">
                      <Col sm='6'>
                        <Form.Label>Master Airway Bill <span></span></Form.Label>
                        <Form.Control type="text"
                          name='airway_bill'
                          value={formData.mawb || ''}
                          maxLength={13}
                          // maxLength='5' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5); }}
                          onChange={(e) => handleFormChange('mawb', e.target.value)}
                        />
                      </Col>
                      <Col sm='6'></Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-2" controlId="exampleForm.ControlInput1">
                      <Col sm='6'>
                        <Form.Label>Label Present <span>*</span></Form.Label>
                        <Form.Check
                          inline
                          label="Yes"
                          name="label_present"
                          type='radio'
                          id='Yes'
                          value="Y"
                          checked={formData.label_present == 'Y'}
                          onChange={(e) => handleFormChange("label_present", e.target.value)}
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="label_present"
                          type='radio'
                          id='No'
                          value="N"
                          checked={formData.label_present == 'N'}
                          onChange={(e) => handleFormChange("label_present", e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                    {/* {formData.label_present === 'Y' && */}
                    <Form.Group as={Row} className="mb-2" controlId="exampleForm.ControlInput1">
                      <Col sm='6'>
                        <Form.Label>Label<span></span></Form.Label>
                        <Form.Control type="text"
                          name='label'
                          value={formData.label || ''}
                          onChange={(e) => handleFormChange('label', e.target.value)}
                        />
                      </Col>
                      <Col sm='6'>
                        <Form.Label>Shipment Number<span></span></Form.Label>
                        <Form.Control type="text"
                          name='shipment_no'
                          value={formData.shipment_no || ''}
                          onChange={(e) => handleFormChange('shipment_no', e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                    {/* } */}
                    <Form.Group as={Row} className="mb-2" controlId="exampleForm.ControlInput1">
                      <Col sm='6'>
                        <Form.Label>Airport Origin<span></span></Form.Label>
                        <Select
                          options={getDestination}
                          onChange={(e) => handleFormChange("airport_origin", e.value)}
                          placeholder="Select Airport Origin"
                          className="autoslct w-100"
                          name="airport_origin"
                          value={getDestination.find(option => option.value === formData.airport_origin) || ''}
                        />
                      </Col>
                      <Col sm='6'>
                        <Form.Label>Consignee Name<span></span></Form.Label>
                        <Form.Control type="text"
                          name='airport_origin'
                          value={formData.consignee_name || ''}
                          maxLength={13}
                          // maxLength='5' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5); }}
                          onChange={(e) => handleFormChange('consignee_name', e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                    {/* {formData.label_present === 'Y' && */}
                    <Form.Group as={Row} className="mb-2" controlId="exampleForm.ControlInput1">
                      <Col sm='6'>
                        <Form.Label>Storage Location<span></span></Form.Label>
                        <Form.Control type="text"
                          name='storage_loc'
                          value={formData.storage_loc || ''}
                          onChange={(e) => handleFormChange('storage_loc', e.target.value)}
                        />
                      </Col>
                      <Col sm='6'>

                      </Col>
                    </Form.Group>
                    {/* } */}
                  </div>
                  <div className='missing_info modal_from'>
                    <h4>House AWB's</h4>
                    <p></p>

                    <div className='expcet_hawb'>
                      {savedHouseAwbs.map((item, idx) => (
                        <div key={idx} className='hawb_box'>
                          <div className='d-flex justify-content-between align-items-center'>
                            <div> <h3>{item.hawb_no}</h3> </div>
                            <div>
                              <Button variant="link" onClick={() => handleEditHawb(idx)}> <img src={Edit} /></Button>
                              <Button variant="link" onClick={() => handleDeleteHawb(idx)}> <img src={Trash} /></Button>
                            </div>
                          </div>
                          <div>
                            {item.packing_groups.map((g, gidx) => (
                              <div key={gidx}>
                                <h4>{g.packaging}</h4>
                                <div>
                                  <span>Pieces: {g.e_pcs}</span> <span> Weight: {g.e_weight}</span>
                                </div>
                                <ul>
                                  <li></li>
                                  <li></li>
                                </ul>
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </Col>
                <Col sm='6'>
                  <div className='missing_info modal_from h-100'>
                    <h4>House AWB's Information</h4>
                    <p></p>
                    {!hawbShow &&
                      <div className='expt_add_hwb'>
                        <Button onClick={() => setHawbShow(true)}>Add House AWB's</Button>
                      </div>
                    }
                    {hawbShow &&
                      <Form.Group as={Row} className="mb-2" controlId="exampleForm.ControlInput1">
                        <Col sm='6'>
                          <Form.Label>House AWB's<span></span></Form.Label>
                          <Form.Control type="text"
                            name='hawb_no'
                            value={houseAwbInput}
                            onChange={e => setHouseAwbInput(e.target.value)}
                            maxLength={13}
                          />
                        </Col>
                        <Col sm='6' className='align-self-end hawb_addg'>
                          <div className='text-end'><Button variant="outline-primary" onClick={handleAddGroup}> <FontAwesomeIcon icon={faPlus} />Add Group</Button></div>
                        </Col>

                        <Col sm='12' className='mt-3'>
                          <Accordion defaultActiveKey="0" flush>
                            {shipmentGroups.map((group, idx) => (
                              <Accordion.Item eventKey={idx.toString()} key={idx}>
                                <Accordion.Header>Group {idx + 1}</Accordion.Header>
                                <Accordion.Body>
                                  <Form.Group className="mb-2">
                                    <Form.Label>Packaging<span></span></Form.Label>
                                    <Form.Select
                                      value={group.packaging}
                                      onChange={e => handleGroupChange(idx, 'packaging', e.target.value)}
                                    >
                                      <option value="">Select Packaging</option>
                                      {getPackaging?.map(pack =>
                                        <option value={pack.value}>{pack.label}</option>
                                      )}
                                      {/* <option value="Envelope">Envelope</option>
                                      <option value="Pallet">Pallet</option>
                                      <option value="Carton Box">Carton Box</option>
                                      <option value="Crate">Crate</option>
                                      <option value="Barrel">Barrell</option> */}
                                    </Form.Select>
                                  </Form.Group>
                                  <Form.Group as={Row} className="mb-2">
                                    <Col sm='6'>
                                      <Form.Label>Expected Pieces<span></span></Form.Label>
                                      <Form.Control
                                        type="text"
                                        value={group.e_pcs}
                                        onChange={e => handleGroupChange(idx, 'e_pcs', e.target.value)}
                                      />
                                    </Col>
                                    <Col sm='6'>
                                      <Form.Label>Expected Weight<span></span></Form.Label>
                                      <Form.Control
                                        type="text"
                                        value={group.e_weight}
                                        onChange={e => handleGroupChange(idx, 'e_weight', e.target.value)}
                                      />
                                    </Col>
                                  </Form.Group>

                                  <Form.Group as={Row} className="mb-2" controlId="exampleForm.ControlInput1">
                                    <Col sm='6'>
                                      <Form.Label>Pieces Confirm <span></span></Form.Label>
                                      <Form.Check
                                        inline
                                        label="Yes"
                                        name={'pcs_conf' + idx}
                                        type='radio'
                                        id={'PYes_' + idx}
                                        value="Y"
                                        checked={group.pcs_conf == 'Y'}
                                        onChange={(e) => handleGroupChange(idx, "pcs_conf", e.target.value)}
                                      />
                                      <Form.Check
                                        inline
                                        label="No"
                                        name={'pcs_conf' + idx}
                                        type='radio'
                                        id={'PNo_' + idx}
                                        value="N"
                                        checked={group.pcs_conf == 'N'}
                                        onChange={(e) => handleGroupChange(idx, "pcs_conf", e.target.value)}
                                      />
                                    </Col>
                                  </Form.Group>
                                  {/* {group.pcs_conf === 'Y' &&
                                    <> */}
                                  <Form.Group as={Row} className="mb-2" controlId="exampleForm.ControlInput1">
                                    <Col sm='6'>
                                      <Form.Label>Accepted Pcs<span></span></Form.Label>
                                      <Form.Control type="text"
                                        name='a_pcs'
                                        value={group.a_pcs || ''}
                                        onChange={(e) => handleGroupChange(idx, 'a_pcs', e.target.value)}
                                      />
                                    </Col>
                                    <Col sm='6'>
                                      <Form.Label>Accepted Weight<span></span></Form.Label>
                                      <Form.Control type="text"
                                        name='a_weight'
                                        value={group.a_weight || ''}
                                        onChange={(e) => handleGroupChange(idx, 'a_weight', e.target.value)}
                                      />
                                    </Col>
                                  </Form.Group>
                                  <Form.Group as={Row} className="mb-2" controlId="exampleForm.ControlInput1">
                                    <Col sm='6'>
                                      <Form.Label>Location<span></span></Form.Label>
                                      <Form.Control type="text"
                                        name='loc'
                                        value={group.loc || ''}
                                        onChange={(e) => handleGroupChange(idx, 'loc', e.target.value)}
                                      />
                                    </Col>
                                    <Col sm='6'>

                                    </Col>
                                  </Form.Group>
                                  {/* </>
                                  } */}

                                  <Form.Group as={Row} className="mb-2">
                                    <Form.Label>File Upload</Form.Label>
                                    <div>
                                      <div
                                        className='dropfile'
                                        onDrop={e => handleGroupDrop(idx, e)}
                                        onDragOver={handleGroupDragOver}
                                        style={{ padding: '10px 0' }}
                                      >
                                        <h3>Drag and drop files here</h3>
                                        <button className='btn btn-primary drpbtn' onClick={e => { e.preventDefault(); document.getElementById(`group-file-input-${idx}`).click(); }}>Browse Files</button>
                                        <span>Maximum file size 4 MB</span>
                                        <input
                                          type="file"
                                          id={`group-file-input-${idx}`}
                                          style={{ display: 'none' }}
                                          onChange={e => handleGroupFileChange(idx, e)}
                                          multiple
                                        />
                                      </div>
                                      <div className='uploadbox'>
                                        {Array.isArray(group.files) && group.files.map((file, fileIdx) => (
                                          <div key={fileIdx} className='uploadfil w-100'>
                                            {file && file.type && file.type.startsWith && file.type.startsWith('image/') ? (
                                              <>
                                                <img
                                                  src={URL.createObjectURL(file)}
                                                  alt="Preview"
                                                  style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                                                />
                                                <span>{file.name}</span>
                                              </>
                                            ) : file && file.name ? (
                                              <span className='d-flex'><img src={Docmnt} className='fileimg' /> {file.name}</span>
                                            ) : null}
                                            <button className='dltbtn' type="button" onClick={() => handleGroupDeleteFile(idx, fileIdx)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </Form.Group>
                                  {shipmentGroups.length > 1 && (
                                    <Button
                                      variant="outline-primary"
                                      className="w-100"
                                      onClick={() => handleDeleteGroup(idx)}
                                    >
                                      Delete Group
                                    </Button>
                                  )}
                                </Accordion.Body>
                              </Accordion.Item>
                            ))}
                          </Accordion>
                          <Button
                            variant="primary"
                            className="w-100 mt-2"
                            onClick={handleSaveHawb}
                          >
                            {editIndex !== null ? 'Update Hawb' : 'Save Hawb'}
                          </Button>
                        </Col>
                      </Form.Group>
                    }
                  </div>
                </Col>
              </Row>
            </>
          }
          {modalFor == 'B' &&
            <>
              <h3>Accept Shipment - Import (Back to Back)</h3>
              <div className='missing_info modal_from mt-4'>
                <h4>Shipment Information</h4>
                <p></p>
                <Form.Group as={Row} className="mb-2" controlId="exampleForm.ControlInput1">
                  <Col sm='6'>
                    <Form.Label>Master Airway Bill <span></span></Form.Label>
                    <Form.Control type="text"
                      name='mawb'
                      value={formData.mawb || ''}
                      maxLength={13}
                      // maxLength='5' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5); }}
                      onChange={(e) => handleFormChange('mawb', e.target.value)}
                    />
                  </Col>
                  <Col sm='6'></Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-2" controlId="exampleForm.ControlInput1">
                  <Col sm='6'>
                    <Form.Label>Label Present <span>*</span></Form.Label>
                    <Form.Check
                      inline
                      label="Yes"
                      name="label_present"
                      type='radio'
                      id='Yes'
                      value="Y"
                      checked={formData.label_present == 'Y'}
                      onChange={(e) => handleFormChange("label_present", e.target.value)}
                    />
                    <Form.Check
                      inline
                      label="No"
                      name="label_present"
                      type='radio'
                      id='No'
                      value="N"
                      checked={formData.label_present == 'N'}
                      onChange={(e) => handleFormChange("label_present", e.target.value)}
                    />
                  </Col>
                </Form.Group>
                {/* {formData.label_present === 'Y' && */}
                <Form.Group as={Row} className="mb-2" controlId="exampleForm.ControlInput1">
                  <Col sm='6'>
                    <Form.Label>Label<span></span></Form.Label>
                    <Form.Control type="text"
                      name='label'
                      value={formData.label || ''}
                      onChange={(e) => handleFormChange('label', e.target.value)}
                    />
                  </Col>
                  <Col sm='6'>
                    <Form.Label>Shipment Number<span></span></Form.Label>
                    <Form.Control type="text"
                      name='shipment_no'
                      value={formData.shipment_no || ''}
                      onChange={(e) => handleFormChange('shipment_no', e.target.value)}
                    />
                  </Col>
                </Form.Group>
                {/* } */}
                <Form.Group as={Row} className="mb-2" controlId="exampleForm.ControlInput1">
                  <Col sm='6'>
                    <Form.Label>Airport Origin<span></span></Form.Label>
                    <Select
                      options={getDestination}
                      onChange={(e) => handleFormChange("airport_origin", e.value)}
                      placeholder="Select Airport Origin"
                      className="autoslct w-100"
                      name="airport_origin"
                      value={getDestination.find(option => option.value === formData.airport_origin) || ''}
                    />
                    {/* <Form.Control
                              as="select"
                              name="airport_origin"
                              value={formData.airport_origin}
                              // onChange={(e) => handleInputChange("airport_origin", e.target.value)}
                            >
                              <option value="">Select Airport Origin</option>
                              {getDestination.map((airport) => (
                                <option key={airport.value} value={airport.value}>
                                  {airport.label}
                                </option>
                              ))}
                            </Form.Control> */}
                  </Col>
                  <Col sm='6'>
                    <Form.Label>Consignee Name<span></span></Form.Label>
                    <Form.Control type="text"
                      name='consignee_name'
                      value={formData.consignee_name || ''}
                      maxLength={13}
                      // maxLength='5' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5); }}
                      onChange={(e) => handleFormChange('consignee_name', e.target.value)}
                    />
                  </Col>
                </Form.Group>
                {/* {formData.label_present === 'Y' && */}
                <Form.Group as={Row} className="mb-2" controlId="exampleForm.ControlInput1">
                  <Col sm='6'>
                    <Form.Label>Storage Location<span></span></Form.Label>
                    <Form.Control type="text"
                      name='storage_loc'
                      value={formData.storage_loc || ''}
                      onChange={(e) => handleFormChange('storage_loc', e.target.value)}
                    />
                  </Col>
                  <Col sm='6'>

                  </Col>
                </Form.Group>
                {/* } */}
              </div>
              <div className='missing_info modal_from'>
                <h4>Shipment Groups</h4>
                <p></p>
                <Accordion defaultActiveKey="0" flush>
                  {shipmentGroups.map((group, idx) => (
                    <Accordion.Item eventKey={idx.toString()} key={idx}>
                      <Accordion.Header>Group {idx + 1}</Accordion.Header>
                      <Accordion.Body>
                        <Form.Group className="mb-2">
                          <Form.Label>Packaging<span></span></Form.Label>
                          <Form.Select
                            value={group.packaging}
                            onChange={e => handleGroupChange(idx, 'packaging', e.target.value)}
                          >
                            <option value="">Select Packaging</option>
                            {getPackaging?.map(pack =>
                              <option value={pack.value}>{pack.label}</option>
                            )}
                            {/* <option value="Envelope">Envelope</option>
                            <option value="Pallet">Pallet</option>
                            <option value="Carton Box">Carton Box</option>
                            <option value="Crate">Crate</option> */}
                          </Form.Select>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-2">
                          <Col sm='6'>
                            <Form.Label>Expected Pieces<span></span></Form.Label>
                            <Form.Control
                              type="text"
                              value={group.e_pcs}
                              onChange={e => handleGroupChange(idx, 'e_pcs', e.target.value)}
                            />
                          </Col>
                          <Col sm='6'>
                            <Form.Label>Expected Weight<span></span></Form.Label>
                            <Form.Control
                              type="text"
                              value={group.e_weight}
                              onChange={e => handleGroupChange(idx, 'e_weight', e.target.value)}
                            />
                          </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-2" controlId="exampleForm.ControlInput1">
                          <Col sm='8'>
                            <Form.Label>Pieces Confirm <span></span></Form.Label>
                            <Form.Check
                              inline
                              label="Yes"
                              name={'pcs_conf' + idx}
                              type='radio'
                              id={'PYes_' + idx}
                              value="Y"
                              checked={group.pcs_conf == 'Y'}
                              onChange={(e) => handleGroupChange(idx, "pcs_conf", e.target.value)}
                            />
                            <Form.Check
                              inline
                              label="No"
                              name={'pcs_conf' + idx}
                              type='radio'
                              id={'PNo_' + idx}
                              value="N"
                              checked={group.pcs_conf == 'N'}
                              onChange={(e) => handleGroupChange(idx, "pcs_conf", e.target.value)}
                            />
                          </Col>
                        </Form.Group>
                        {/* {group.pcs_conf === 'Y' &&
                          <> */}
                        <Form.Group as={Row} className="mb-2" controlId="exampleForm.ControlInput1">
                          <Col sm='6'>
                            <Form.Label>Accepted Pcs<span></span></Form.Label>
                            <Form.Control type="text"
                              name='a_pcs'
                              value={group.a_pcs || ''}
                              onChange={(e) => handleGroupChange(idx, 'a_pcs', e.target.value)}
                            />
                          </Col>
                          <Col sm='6'>
                            <Form.Label>Accepted Weight<span></span></Form.Label>
                            <Form.Control type="text"
                              name='a_weight'
                              value={group.a_weight || ''}
                              onChange={(e) => handleGroupChange(idx, 'a_weight', e.target.value)}
                            />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-2" controlId="exampleForm.ControlInput1">
                          <Col sm='6'>
                            <Form.Label>Location<span></span></Form.Label>
                            <Form.Control type="text"
                              name='loc'
                              value={group.loc || ''}
                              onChange={(e) => handleGroupChange(idx, 'loc', e.target.value)}
                            />
                          </Col>
                          <Col sm='6'>

                          </Col>
                        </Form.Group>
                        {/* </>
                        } */}

                        <Form.Group as={Row} className="mb-2">
                          <Form.Label>File Upload</Form.Label>
                          <div>
                            <div
                              className='dropfile'
                              onDrop={e => handleGroupDrop(idx, e)}
                              onDragOver={handleGroupDragOver}
                              style={{ padding: '10px 0' }}
                            >
                              <h3>Drag and drop files here</h3>
                              <button className='btn btn-primary drpbtn' onClick={e => { e.preventDefault(); document.getElementById(`group-file-input-${idx}`).click(); }}>Browse Files</button>
                              <span>Maximum file size 4 MB</span>
                              <input
                                type="file"
                                id={`group-file-input-${idx}`}
                                style={{ display: 'none' }}
                                onChange={e => handleGroupFileChange(idx, e)}
                                multiple
                              />
                            </div>
                            <div className='uploadbox'>
                              {Array.isArray(group.files) && group.files.map((file, fileIdx) => (
                                <div key={fileIdx} className='uploadfil w-100'>
                                  {file && file.type && file.type.startsWith && file.type.startsWith('image/') ? (
                                    <>
                                      <img
                                        src={URL.createObjectURL(file)}
                                        alt="Preview"
                                        style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                                      />
                                      <span>{file.name}</span>
                                    </>
                                  ) : file && file.name ? (
                                    <span className='d-flex'><img src={Docmnt} className='fileimg' /> {file.name}</span>
                                  ) : null}
                                  <button className='dltbtn' type="button" onClick={() => handleGroupDeleteFile(idx, fileIdx)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                </div>
                              ))}
                            </div>
                          </div>
                        </Form.Group>
                        {shipmentGroups.length > 1 && (
                          <Button
                            variant="outline-primary"
                            className="w-100"
                            onClick={() => handleDeleteGroup(idx)}
                          >
                            Delete Group
                          </Button>
                        )}
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
                <Button
                  variant="primary"
                  className="w-100"
                  onClick={handleAddGroup}
                >
                  + Add Group
                </Button>
              </div>
            </>
          }
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex w-50 mx-auto are_bottom'>
            <Button variant="secondary" onClick={closeModal}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleConfirmation}>
              Submit
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default Release